<template>
  <v-app>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="4"
        sm="4"
      >
        <base-material-card color="primary">
          <template v-slot:heading>
            <v-row>
              <v-col
                cols="12"
                md="9"
              >
                <div
                  class="text-h3 font-weight-light"
                >
                  Crear usuario
                </div>
                <div
                  class="text-subtitle-1 font-weight-light"
                >
                  Ingrese sus datos para el registro
                </div>
              </v-col>
              <v-col
                cols="1"
                md="1"
              >
                <v-spacer />
                <v-btn
                  icon
                  outlined
                  fab
                  to="/Login"
                >
                  <v-icon>
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <v-container class="py-0">
            <v-form
              ref="form"
              v-model="valid"
            >
              <v-text-field
                v-model="credentials.username"
                prepend-icon="mdi-at"
                type="text"
                label="Nombre de usuario"
                :rules="rules.username"
                hint="usuario"
              />
              <v-text-field
                v-model="credentials.email "
                label="Correo Electronico"
                prepend-icon="mdi-at"
                :rules="rules.email"
                type="email"
              />
              <v-text-field
                v-model="credentials.first_name "
                label="Nombre"
                :rules="rules.nombre"
                prepend-icon="mdi-card-account-details-outline"
                type="text"
              />
              <v-text-field
                v-model="credentials.last_name "
                label="Apellido"
                :rules="rules.apellido"
                prepend-icon="mdi-card-account-details-outline"
                type="text"
              />
              <v-text-field
                v-model="credentials.password "
                label="Contraseña"
                prepend-icon="mdi-lock"
                :rules="rules.password"
                type="password"
              />
              <v-text-field
                v-model="confirmacion.password "
                label=" Confirmar Contraseña"
                prepend-icon="mdi-lock"
                :rules="rules.password_confirmation"
                type="password"
              />
              <v-row
                align="center"
                justify="center"
                style="margin-top:30px;margin-bottom:30px"
              >
                <v-btn
                  color="primary"
                  class="mr-0"
                  :disabled="!valid"
                  @click="Registro()"
                >
                  Registrar
                </v-btn>
              </v-row>
            </v-form>
          </v-container>
        </base-material-card>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
  import router from '../../router'
  import axios from 'axios'
  export default {
    name: 'Auth',
    data: () => ({
      expandOnHover: false,
      credentials: {},
      confirmacion: [],
      valid: true,
      loading: false,
      rules: {
        email: [
          v => !!v || 'El valor es requerido',
          v => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(v) || 'Formato de correo invalido'
          },
        ],
        username: [
          v => !!v || 'El usuario es requerido',
        ],
        nombre: [
          v => !!v || 'El nombre es requerido',
        ],
        apellido: [
          v => !!v || 'El apellido es requerido',
        ],
        password: [
          v => !!v || 'La contraseña es requerida',
          v => (v && v.length >= 5) || 'Debe tener por lo menos 8 digitos',
        ],
        password_confirmation: [
          v => !!v || 'El valor es requerido',
          v => (v === this.credentials.password) || 'La confirmación no es igual',
        ],
      },
    }),
    methods: {
      Registro () {
        axios.post(window.location.protocol + '//' + window.location.hostname + ':85/inventrio/' + 'Usuarios/', this.credentials)
          .then(res => {
            this.loading = true
            this.$swal({
              text: 'Usuario registrado',
              showConfirmButton: true,
              showCloseButton: false,
              timer: 30000,
              icon: 'success',
            })
            router.push('/login')
          })
          .catch(err => {
            console.log(err)
            this.$swal({
              text: 'Falta algun dato',
              showConfirmButton: false,
              showCloseButton: false,
              timer: 3000,
              icon: 'warning',
            })
          })
      },
    },
  }
</script>
<style scoped>
  h2 {
      position: relative;
      font-size: 30px;
      z-index: 1;
      overflow: hidden;
      text-align: center;
  }
  h2:before, h2:after {
      position: absolute;
      top: 51%;
      overflow: hidden;
      width: 50%;
      height: 1px;
      content: '\a0';
      background-color: rgb(111, 106, 106);
  }
  h2:before {
      margin-left: -50%;
      text-align: right;
  }
</style>
